import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PCA9685: React.FC = () => {
  const navigate = useNavigate();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);
  const [showPdf, setShowPdf] = useState(false);

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      overflow: 'auto',
      padding: '1rem'
    }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
          <button
          onClick={() => navigate('/class-materials/ai-robot-project')}
            style={{
              marginRight: '1rem',
              padding: '0.5rem 1rem',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            ← 돌아가기
          </button>
          <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600 }}>PCA9685 확장 보드 사용 방법</h1>
        </div>
        
        <div style={{ marginBottom: '1rem', border: '1px solid #ccc', padding: '0.8rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontWeight: 'bold', marginBottom: '1rem', margin: '0 0 1rem 0' }}>
            📚 목차
          </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
              <a href="#AI 로봇 제작 프로젝트 평가 기준" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                AI 로봇 제작 프로젝트 평가 기준
              </a>
            </li>
            <li style={{marginBottom: '8px'}}>
              <a href="#프로젝트 일정" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                프로젝트 일정
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
              <a href="#주행 코스 설명" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                주행 코스 설명
            </a>
          </li>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '6px' }}>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-변수-선언하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite를 위한 변수 선언
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-변수-선언하면서-동시에-글자색-배경색-바꾸기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 변수 선언하면서 동시에 글자색, 배경색 바꾸기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-글자-크기-조정하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 글자 크기 조정하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-글자-테두리-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 글자 테두리 추가하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-박스-테두리-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 박스 테두리 추가하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-텍스트-변경하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 텍스트 변경하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="#text-sprite-아이콘-추가하기" style={{ textDecoration: 'none', color: '#555' }}>
                  TextSprite 아이콘 추가하기
                </a>
              </li>
            </ul>
        </ul>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'end', marginBottom: '1rem', gap: '1rem' }}>
          <p style={{ color: '#666', margin: 0 }}>
            본 프로젝트는 이동할 수 있는 로봇의 구조를 설계하고 Micro:bit와 AI 모델을 활용하여 로봇을 조종하는 프로젝트로 협업능력, 의사소통 능력 및 기술적 문제해결능력을 기르기 위해 설계된 프로젝트입니다.
          </p>
        </div>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="AI 로봇 제작 프로젝트 평가 기준">
          ⚠️PCA9685 확장 보드 사용 방법
        </h2>
        <p style={{ color: '#666', marginBottom: '1rem' }}>
          PCA보드는 마이크로비트에서 사용하는 서보모터를 제어하기 위해 본 프로젝트에서 사용하는 보드입니다.<br/>
          보드에는 
        </p>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="주행 코스 설명">
          🏁 주행 코스 설명
        </h2>
        
        <img
            src="/images/microbit/AiRobotProject/course.png"
            alt="주행 코스 설명"
            style={{ width: '100%', height: 'auto', borderRadius: '8px', display: 'block', margin: '0 auto' }}
          />
        <p style={{ color: '#666', margin: 0 }}>
          주행 코스는 시작 - 전진 코스 - 장애물 코스 - 3초 일시 정지 코스 - 도착으로 총 5개의 코스로 구성되어 있습니다.<br/>
          주행 목표 시간은 30초 입니다.<br/>
        </p>
        
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="사용 가능한 재료 목록">
          🪛 사용 가능한 재료 목록
        </h2>
        
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1rem' }}>
          <tr>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>
              <img
              src="/images/microbit/AiRobotProject/bar.png"
              alt="타공 막대"
              style={{ width: '30%', height: 'auto' }}
              />
            </td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>
              <img
                src="/images/microbit/AiRobotProject/servo.png"
                alt="SG90 서보모터"
                style={{ width: '30%', height: 'auto' }}
              />
            </td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>
              <img
                src="/images/microbit/AiRobotProject/bar.png"
                alt="타공 막대"
                style={{ width: '30%', height: 'auto' }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>타공 막대</td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>타공 막대</td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>타공 막대</td>
          </tr>
        </table>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }} id="서보모터 테스트 하기">
          로봇 제작하기
        </h2>
        <p style={{ color: '#666', marginBottom: '1rem' }}>
          로봇을 제작하기 전 서보모터의 각도를 제어해 적절한 각도를 찾아봅니다.
        </p>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-변수-선언하기">
          <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
            1. 서보모터 테스트 후 각도 설정
          </h3>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
          서보모터 2개를 테스트 하기 위한 블록 세트입니다. <a href="https://makecode.microbit.org/S34118-62831-33468-16536" target="_blank" rel="noopener noreferrer"><b>링크</b></a>를 클릭한 뒤 코드 수정 버튼을 눌러 사용하세요.<br/>
          확장 보드를 사용하기에 "PCA9685"라는 확장블록을 사용합니다.<br/>
          </p>
          <div style={{ position: 'relative', height: 'calc(300px + 5em)', width: '100%', overflow: 'hidden' }}>
            <iframe 
              style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }} 
              src="https://makecode.microbit.org/---codeembed#pub:_g0A8zwccg11D" 
              allowFullScreen 
              frameBorder="0" 
              sandbox="allow-scripts allow-same-origin allow-popups"
            ></iframe>
          </div>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
          사용 순서는 아래와 같습니다.<b style={{color:' blue' }}>(64는 채널로 절대 변경하지 않습니다.)</b><br/>
          1. 확장 보드에 꽂혀있는 서보모터 변경하기(0번핀에 꽂혀있는 서보모터: Servo1, 5번핀에 꽂혀있는 서보모터: Servo6)<br/>
          2. A버튼을 눌렀을 때 서보모터가 돌아갈 각도 설정(Servo1을 0도로 설정할 경우: set servo position <b style={{ color: 'red' }}>Servo1 0</b> 64)<br/>
          3. B버튼을 눌렀을 때 서보모터가 돌아갈 각도 설정(Servo1을 180도로 설정할 경우: set servo position <b style={{ color: 'red' }}>Servo1 180</b> 64)<br/>
          4. 마이크로비트에 Usb 케이블 연결 후 코드 다운로드하기<br/>
          5. 확장보드에 Usb 케이블 연결 혹은 배터리 연결 후 A버튼, B버튼을 눌러서 테스트하기
          6. 이후 제작하고 있는 로봇에 맞게 동작 각도를 설정하기<br/>
          </p>
          <p style={{ color: '#666', marginBottom: '0.5rem' }}>
          사용 예시:
          </p>
          <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f5f5f5', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <img
            src="/images/microbit/AiRobotProject/testcode.png"
            alt="Text Sprite 블록들"
              style={{ width: '100%', height: 'auto' }}
            />
            </div>
          </div>
        </div>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-변수-선언하면서-동시에-글자색-배경색-바꾸기">
          <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
          2. 로봇 동작 코드 사용하기기
          </h3>
          <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', marginBottom: '1rem' }}>
            <p style={{ color: '#666', margin: 0 }}>
              서보모터의 작동 각도를 정했다면, 이제 앞으로 가는지를 확인할 때입니다.<br/>
              <a href="https://makecode.microbit.org/S29032-55412-44700-92984" target="_blank" rel="noopener noreferrer"><b>링크</b></a>를 클릭한 뒤 코드 수정 버튼을 눌러 사용하세요.<br/>
            </p>
          </div>
          <div style={{ position: 'relative', height: 'calc(300px + 5em)', width: '100%', overflow: 'hidden' }}>
            <iframe 
              style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }} 
              src="https://makecode.microbit.org/---codeembed#pub:S29032-55412-44700-92984" 
              allowFullScreen 
              frameBorder="0" 
              sandbox="allow-scripts allow-same-origin allow-popups"
            ></iframe>
          </div>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
            A버튼을 눌렀을 때에는 정지 동작을, B버튼을 눌렀을 때에는 앞으로 가는 동작이 담긴 코드입니다.<br/>
            제작하고 있는 로봇에 맞게 코드를 수정하세요.<br/>
          </p>
        </div>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-글자-크기-조정하기">
          <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
          3. TextSprite 글자 크기 조정하기
          </h3>
          <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', marginBottom: '1rem' }}>
            <img
          src="/images/makecodearcade/explains/SpriteText/arcadetext11.png"
          alt="Text Sprite 글자 크기 조정하기"
            style={{ width: '30%', height: 'auto' }}
          />
            <p style={{ color: '#666', margin: 0 }}>
          textSprite 변수 안의 text 스프라이트의 크기(height)를 조정할 수 있습니다.<br/>
          기본 높이는 0으로 시작하며 원하는 높이로 조정할 수 있습니다.<br/>
          <b style={{ color: 'red' }}>다만, 아직 한국어 텍스트에 대해서는 적용되지 않습니다.ㅠㅠ....</b>
          </p>
          </div>
          <p style={{ color: '#666', marginBottom: '0.5rem' }}>
          사용 예시:
          </p>
          <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f5f5f5', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext13.png"
            alt="Text Sprite 글자 크기 조정 적용"
              style={{ width: '70%', height: 'auto' }}
            />
              <div style={{ width: '1px', height: '100px', backgroundColor: '#ddd' }}></div>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext14.png"
            alt="Text Sprite 글자 크기 조정 시뮬레이터"
              style={{ width: '25%', height: 'auto' }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-글자-테두리-추가하기">
            <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
            4. TextSprite 글자 테두리 추가하기
            </h3>
            <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', marginBottom: '1rem' }}>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext15.png"
            alt="Text Sprite 글자 테두리 추가 적용"
              style={{ width: '30%', height: 'auto' }}
            />
            <p style={{ color: '#666', margin: 0 }}>
            textSprite 변수 안의 text 스프라이트의 테두리의 <b>두께</b>와 <b>색상</b>을 추가할 수 있습니다.
            </p>
            </div>
            <p style={{ color: '#666', marginBottom: '0.5rem' }}>
            사용 예시:
            </p>
            <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f5f5f5', marginBottom: '1rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <img
              src="/images/makecodearcade/explains/SpriteText/arcadetext16.png"
              alt="Text Sprite 글자 테두리 추가 적용"
                style={{ width: '70%', height: 'auto' }}
              />
                <div style={{ width: '1px', height: '100px', backgroundColor: '#ddd' }}></div>
                <img
              src="/images/makecodearcade/explains/SpriteText/arcadetext17.png"
              alt="Text Sprite 글자 테두리 추가 시뮬레이터"
                style={{ width: '25%', height: 'auto' }}
                />
              </div>
            </div>
          </div>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-박스-테두리-추가하기">
          <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
          5. TextSprite 박스 테두리 추가하기
          </h3>
          <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', marginBottom: '1rem' }}>
            <img
          src="/images/makecodearcade/explains/SpriteText/arcadetext18.png"
          alt="Text Sprite 박스 테두리 추가 적용"
            style={{ width: '30%', height: 'auto' }}
          />
            <p style={{ color: '#666', margin: 0 }}>
            textSprite 변수 안의 text 스프라이트의 박스 테두리의 <b>두께</b>와 <b>색상</b>을 추가할 수 있습니다.
            </p>
          </div>
          <p style={{ color: '#666', marginBottom: '0.5rem' }}>
          사용 예시:
          </p>
          <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f5f5f5', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext19.png"
            alt="Text Sprite 박스 테두리 추가 적용"
              style={{ width: '70%', height: 'auto' }}
            />
              <div style={{ width: '1px', height: '100px', backgroundColor: '#ddd' }}></div> 
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext20.png"
            alt="Text Sprite 박스 테두리 추가 시뮬레이터"
              style={{ width: '25%', height: 'auto' }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-텍스트-변경하기">
          <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
          6. TextSprite 텍스트 변경하기
          </h3>
          <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', marginBottom: '1rem' }}>
            <img
          src="/images/makecodearcade/explains/SpriteText/arcadetext21.png"
          alt="Text Sprite 텍스트 변경하기"
            style={{ width: '30%', height: 'auto' }}
          />
            <p style={{ color: '#666', margin: 0 }}>
            textSprite 변수 안의 text 스프라이트의 텍스트를 변경할 수 있습니다.
            </p>
          </div>
          <p style={{ color: '#666', marginBottom: '0.5rem' }}>
          사용 예시:
          </p>
          <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f5f5f5', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext22.png"
            alt="Text Sprite 텍스트 변경하기"
              style={{ width: '70%', height: 'auto' }}
            />
              <div style={{ width: '1px', height: '100px', backgroundColor: '#ddd' }}></div>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext23.gif"
            alt="Text Sprite 텍스트 변경하기"
              style={{ width: '25%', height: 'auto' }}
              />
            </div>
          </div>
        </div>

        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: 'rgba(255, 220, 175, 0.8)', marginBottom: '1rem' }} id="text-sprite-아이콘-추가하기">
          <h3 style={{ fontWeight: 700, color: '#1976d2', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
          7. TextSprite 아이콘 추가하기
          </h3>
          <div style={{ display: 'flex', alignItems: 'end', gap: '1rem', marginBottom: '1rem' }}>
            <img
          src="/images/makecodearcade/explains/SpriteText/arcadetext23.png"
          alt="Text Sprite 아이콘 추가하기"
            style={{ width: '30%', height: 'auto' }}
          />
            <p style={{ color: '#666', margin: 0 }}>
            text 스프라이트 앞에 나만의 아이콘을 추가할 수 있습니다.
            </p>
          </div>
          <p style={{ color: '#666', marginBottom: '0.5rem' }}>
          사용 예시:
          </p>
          <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f5f5f5', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext24.png"
            alt="Text Sprite 아이콘 블록 추가"
              style={{ width: '70%', height: 'auto' }}
            />
              <div style={{ width: '1px', height: '100px', backgroundColor: '#ddd' }}></div>
              <img
            src="/images/makecodearcade/explains/SpriteText/arcadetext25.png"
            alt="Text Sprite 아이콘 추가하기 시뮬레이터"
              style={{ width: '25%', height: 'auto' }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default PCA9685;